
import { ADD_ENGAGEMENT_ACTIVITY } from "services/url.service";
import { commonTransform } from "../handleTransformation";

export const engagementMetricMutations = {
   addEngagementActivity: {
    getUrl: () => {return ADD_ENGAGEMENT_ACTIVITY},
    transformResponse: (res) => commonTransform(res),
    method: "POST",
  },
};

export const engagementMetricQueries = {
};
